import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReportService } from 'src/app/services/sections/job/report.service';
import moment from 'moment';
import { SiteDetails, WorkforceDay, WorkforceReport } from 'src/app/models/workforce-report.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
  selector: 'workforce-report-bysite',
  templateUrl: './workforce-report-bysite.component.html',
  styleUrls: ['./workforce-report-bysite.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss']
})
export class WorkforceReportBysiteComponent implements OnInit {
  public isDataLoading = false;
  public reportFormGroup: FormGroup;

  private pageCount: number = 0;
  private pageSize: number = 5;
  public totalRecords: number = 0;
  public onDemandFormCount: number = 0;
  public canLoadMoreData: boolean = false;

  public isEmailCached: boolean;
	public isRequestSent: boolean;
	public isEmailInvalid: boolean;
	public isDateSelected: boolean;

  public siteId: number;
  
  public  allDates: WorkforceDay[] = [];
  public siteDetails: SiteDetails;

  public readonly moment = moment;

  constructor(
    private activatedRoute: ActivatedRoute,
		private reportService: ReportService
  ) { }

  ngOnInit() {
    GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
    this.siteId = parseInt(this.activatedRoute.snapshot.paramMap.get('siteId'), 10);

    this.isEmailCached = !!localStorage.getItem('cloud-email');

		this.reportFormGroup = new FormGroup({
			date: new FormControl(null, Validators.required),
			email: new FormControl(this.isEmailCached ? localStorage.getItem('cloud-email') : '', [Validators.required, Validators.email, Validators.minLength(3), Validators.pattern(/\S+/)])
		});

		this.reportFormGroup.get('email').valueChanges.subscribe(
			value => {
				this.isEmailInvalid = this.isEmailInvalid && !this.isRequestSent ? false : this.isEmailInvalid;
				this.checkCrtValue();
			}
		);

		this.reportFormGroup.get('date').valueChanges.subscribe(date => {
			this.isRequestSent = false;
      this.isEmailInvalid = false;
		});

    this.loadNextPage();
  }


  loadNextPage(){
    if(this.isDataLoading){
      return;
    }
    this.pageCount = this.pageCount + 1;
    this.isDataLoading = true;
    this.reportService.getOnDemandFormSummary(this.siteId, this.pageSize, this.pageCount)
    .subscribe(
      data => {
        data.days.forEach(element => {
          this.allDates.push(element);
        });
        this.totalRecords = data.totalRecords;
        this.siteDetails = data.siteDetails;
        this.canLoadMoreData = this.allDates.length < this.totalRecords;
        this.isDataLoading = false;
      }, 
      (error) => {
        this.isDataLoading = false;
        console.log(error);
      }
    );
  }

  private checkCrtValue(){
		const model = this.reportFormGroup.getRawValue();
		if (model.email.indexOf(' ') >= 0){
			this.reportFormGroup.patchValue({email: model.email.replaceAll(' ', '')});
		}
	}

  public 	keyPressed($event: any) {
		if ($event.keyCode === 13 /*Enter */){
			this.checkEmail();
		}
	}

  public checkEmail(): void {
		this.isDataLoading = true;
		const formData = this.reportFormGroup.getRawValue();
		const request: any = {};// as WorkforceReport;
		request.emailAddress = formData.email;
		request.date = formData.date.date;
    request.jobId = formData.date.jobId;

    
		this.reportService.requestWorkforceReportBySite(this.siteId, request).subscribe(res => {
			this.isDataLoading = false;
			this.isRequestSent = true;
			localStorage.setItem('cloud-email', formData.email.trim());
		}, error => {
			this.isDataLoading = false;
			this.isEmailInvalid = true;
		});
    
	}

}
